import { IVehicleResult } from "./types.d"
import { IOpeningHours } from "./features/dealer/types"
import { IVehicle } from "./features/vehicle/types"

export const getVehicleTitle = (v: IVehicleResult | IVehicleResult) => `${v.year || ''} ${v.make || ''} ${v.family || ''} ${v.badge || ''} ${v.badge2nd || ''}`;
export const getVehicleDescriptionLine = (v: IVehicleResult | IVehicleResult) => `${v.doornum || ''} door ${v.bodystyle || ''} ${v.drive || ''}`;
export const getVehicleDescriptionSecondaryLine = (v: IVehicle | IVehicleResult) => `${v.geartype} ${v.enginedesc}`;
export const getVehicleDescriptionTertiaryLine = (v: IVehicle | IVehicleResult) => v.fueltype ? '(' + v.fueltype + ')' : '';
export const getVehicleSummaryLine = (v: IVehicle | IVehicleResult) => v.doornum + ` door ` + v.bodystyle + `  ` + v.drive;
export const getVehicleSpecLine = (v: IVehicle | IVehicleResult) => v.geartype + `  ` + v.enginedesc + ` (` + v.fueltype + `)`;

export const scrollToBeginning = () => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  });
};

export const getArrayFromObject = (obj: object, keyName: string, valName: string) => {
  const ret: Array<any> = Object.keys(obj).map(k => {
    const numArray = k.split('-');
    const num = numArray.length === 2 ? numArray[1] : 'ERROR';
    const val = parseInt((obj as any)[k]);
    const r = {};
    (r as any)[keyName] = num;
    (r as any)[valName] = val;
    return r;
  });
  return ret;
};

export const getFormattedMoney = (v: number, cents: boolean = true) => {
  let r: string = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(v);
  if (!cents){
    const r2 = r.split('.');
    if (r2.length) return r2[0];
  }
  return r;
};

export const getFormattedKms = (v: number) => v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const getFormattedTime = (t: string) => {
  const d = new Date();
  const digits = t.split(':');
  if (digits.length < 2) return t;
  d.setHours(parseInt(digits[0]))
  d.setMinutes(parseInt(digits[1]));
  return d.toLocaleString('en-US', { timeStyle: 'short' });
};
export const hasSameOperatingTimes = (o: IOpeningHours, o2: IOpeningHours) => {
  return o2.OpeningTime == o.OpeningTime && o2.ClosingTime == o.ClosingTime;
};
export const getFormattedOpeningHours = (oh: Array<IOpeningHours>): string => {
  // oh = [
  //   {
  //     Day:"Monday",
  //     OpeningTime:"08:30:00",
  //     ClosingTime:"17:30:00",
  //     IsClosed:true
  //   }, 
  //   {
  //     Day:"Tue",
  //     OpeningTime:"08:30:00",
  //     ClosingTime:"17:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"Wed",
  //     OpeningTime:"08:30:00",
  //     ClosingTime:"17:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"thur",
  //     OpeningTime:"08:30:00",
  //     ClosingTime:"19:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"fri",
  //     OpeningTime:"08:30:00",
  //     ClosingTime:"19:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"sat",
  //     OpeningTime:"08:30:00",
  //     ClosingTime:"17:30:00",
  //     IsClosed:true
  //   }, 
  //   {
  //     Day:"sun",
  //     OpeningTime:"10:00:00",
  //     ClosingTime:"16:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"mon2",
  //     OpeningTime:"10:00:00",
  //     ClosingTime:"16:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"tue2",
  //     OpeningTime:"12:00:00",
  //     ClosingTime:"15:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"wed2",
  //     OpeningTime:"12:00:00",
  //     ClosingTime:"16:30:00",
  //     IsClosed:false
  //   }, 
  //   {
  //     Day:"thu2",
  //     OpeningTime:"12:00:00",
  //     ClosingTime:"17:30:00",
  //     IsClosed:false
  //   }
  // ];
  const str = `{sd} {d} {ed}: {st} to {et}`;
  const lines: Array<string> = [];
  let o: IOpeningHours | null = null;
  let line: string = str;

  for (let i = 0; i != oh.length; ++i){
    const isFirstLine = line == str && !oh[i].IsClosed;
    const isEndLine = o && 
      hasSameOperatingTimes(oh[i],o) &&
      (
        i+1 == oh.length || 
        (oh[i+1].IsClosed || oh[i+1].OpeningTime != o.OpeningTime || oh[i+1].ClosingTime != o.ClosingTime)
      );
    if (isFirstLine){
      line = line.replace('{sd}', oh[i].Day).replace('{st}', getFormattedTime(oh[i].OpeningTime)).replace('{et}', getFormattedTime(oh[i].ClosingTime));
      if (i+1 == oh.length || !hasSameOperatingTimes(oh[i], oh[i+1])){
        line = line.replace('{ed}','').replace(' {d} ', '');
        lines.push(line);
        line = str;
      }
      o = oh[i];
      continue;
    }
    if (isEndLine){
      line = line.replace('{ed}', oh[i].Day).replace('{d}', '-');
      lines.push(line);
      line = str;
    }
  }
  return lines.length ? lines.join('<br />') : '';
};

export const getMonths: Array<string> = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];